/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/left': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M19.06 41.08l23-24.75h13l-18.4 19.8H73.5V46H36.66l18.41 19.8h-13z" _fill="#fff"/><path pid="2" _fill="#fff" d="M62.62 38.11h10.89v39.93H62.62z"/></g></g>'
  }
})
